import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';

import Clients from './reducers/clients';
import Product from './reducers/product';
import Proposal from './reducers/proposal';
import Proposals from './reducers/proposals';
import Operation from './reducers/operations';
import CustomQuotes from './reducers/custom-quotes';
import CreateOperation from './reducers/create-operation';
import OperationAnalysis from './reducers/operation-analysis';

const reducers = combineReducers({
  toastr,
  Clients,
  Product,
  Proposal,
  Operation,
  Proposals,
  CustomQuotes,
  CreateOperation,
  OperationAnalysis,
});

export default reducers;
